import { Box, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { ArrowLeft2 } from 'iconsax-react';
import dynamic from 'next/dynamic';
import React from 'react';

import { DescriptionKit } from 'components/kit/Description';
import { paths } from 'constants/endPoint';
import useCustomMediaQuery from 'hooks/useCustomMediaQuery';
import { getOldBaseURL } from 'utility/baseURL';
import { shimmer } from 'utility/shimmer';

const ImageKit = dynamic(() => import('components/common/Image'), {
	loading: () => <></>,
});

const useStyles = makeStyles((theme) => ({
	root: {
		width: '12.7rem',
		padding: '0.5rem',
		background: theme.palette.background.light,
		borderRadius: theme.shape.medium,
		boxShadow: ` 0px 27px 50px -7px rgba(0, 0, 0, 0.06)`,
		position: 'relative',
		transition: theme.transitions.create(['all', 'transform'], {
			duration: theme.transitions.duration.short,
		}),
		'&:hover': {
			transform: 'scale(1.03)',
			boxShadow: theme.shadows[1],
		},
	},
	BoxImage: {
		borderRadius: theme.shape.medium,
		display: 'flex',
		flexDirection: 'column',
	},
	images: {
		width: '100%',
		height: '100%',
		borderRadius: theme.shape.medium,
	},
	content: {
		padding: ' 0 0.8rem',
		marginTop: '1.6rem',
	},
	hoverArrow: {
		width: '2.1rem',
		height: '0.4rem',
		borderRadius: theme.shape.medium,
		background: theme.palette.secondary[700],
		boxShadow: ` 0px 3px 9px ${theme.palette.secondary[700]}`,
	},
}));

const CategoryBox = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const baseURL = getOldBaseURL();
	const { Name, SupplierCount, size, isArrow, hoverFlag } = props;
	const [hover, setHover] = React.useState(false);
	const { isOnlyLg } = useCustomMediaQuery();

	const generateImage = props?.CategoryImages?.find((fd) => fd.SupplierCategoryImageTypeID === '8')?.FileUrl;
	const imageOfMap = props?.image?.find((item) => item.FileUrl)?.FileUrl;

	return (
		<Box
			className={classes.root}
			onMouseOver={() => hoverFlag && setHover(true)}
			onMouseOut={() => hoverFlag && setHover(false)}
			{...(size === 'large' && { style: { width: '15.9rem', height: '21rem' } })}
		>
			<Box className={classes.BoxImage}>
				<ImageKit
					src={baseURL + `${generateImage || imageOfMap}`}
					className={classes.images}
					width={120}
					height={size === 'large' ? (isOnlyLg ? 120 : 150) : 120}
					objectFit={'cover'}
					placeholder="blur"
					priority
					blurDataURL={`data:image/svg+xml;base64,${shimmer(120, 120)}`}
				/>
			</Box>
			{size !== 'large' && (
				<>
					{(props?.Name || Name) && (
						<Box className={classes.content}>
							<DescriptionKit
								fontStyleTitleProps={{
									color: theme.palette.text.dark,
									fontWeight: 700,
								}}
								variantTitle={'subtitle1'}
								fontStyleSubTitleProps={{
									fontSize: theme.typography.subtitle1,
									color: theme.palette.text.disabled,
									fontWeight: 500,
									marginTop: '0.8rem',
								}}
								direction={'column'}
								title={Name}
								{...(SupplierCount && {
									subTitle: `+${SupplierCount} فروشگاه `,
								})}
								alignItems={'flex-start'}
							/>
						</Box>
					)}
				</>
			)}

			{size === 'large' && isArrow && (
				<Box display={'flex'} alignItems="center" justifyContent={'space-between'} p="1.2rem 0.8rem">
					<Typography
						color={theme.palette.text.dark}
						noWrap
						variant="body1"
						fontWeight={700}
						lineHeight="2.2rem"
					>
						{props?.Name}
					</Typography>
					<ArrowLeft2 size="20" color={theme.palette.text.secondary} />
				</Box>
			)}

			{hover && (
				<Box width="100%" className="element-center">
					<Box component="span" className={classes.hoverArrow} />
				</Box>
			)}
		</Box>
	);
};

CategoryBox.defaultProps = {
	href: paths['/stores'],
	size: 'large',
};

export default CategoryBox;
